export default function Header() {
  return (
    <div className="h-16 w-full bg-gray-900 flex items-center">
      <div className="mx-4">
        <h1 className="text-white font-semibold text-2xl">React Kanban</h1>
      </div>
    </div>
  );
}
